var API_DOMAIN = "https://gmrcrackers.com/api";

export default API_DOMAIN